export default "__VITE_ASSET__DhJmdQd3__"